import { render } from "./QuickEmail.vue?vue&type=template&id=0c2864bd&scoped=true"
import script from "./QuickEmail.vue?vue&type=script&lang=js"
export * from "./QuickEmail.vue?vue&type=script&lang=js"

import "./QuickEmail.vue?vue&type=style&index=0&id=0c2864bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2864bd"]])

export default __exports__